import { K8_NAVTABS } from '@/utils/templates/k8mTemplate/k8m.constants.ts';
import i18n from '@/plugins/i18n';
const k8m = {
  key: 'k8m',
  name: i18n.global.t('k8m'),
  icon: 'k8m',
  navTabs: [
    {
      name: K8_NAVTABS.K8M_CLUSTER_TAB,
    },
    {
      name: K8_NAVTABS.K8M_NODE_TAB,
    },
    {
      name: K8_NAVTABS.K8M_DEP_TAB,
    },
    {
      name: K8_NAVTABS.K8M_STAT_TAB,
    },
    {
      name: K8_NAVTABS.K8M_DAEMON_TAB,
    },
    {
      name: K8_NAVTABS.K8M_POD_TAB,
    },
  ],
};
export default k8m;
